import { z } from "zod";

/**
 * Parsed from OSS `GET /medical/v1/feature-flags`.
 * When adding fields, update the OSS handler that builds this payload for each cx/user.
 */
export const cxFeatureFlagsSchema = z.object({
  shouldShowLegacyDashV1: z.literal(true).optional(),
  /** When true, Featured tab shows the suspects table; omit or false hides it (no suspects API call). */
  shouldShowSuspects: z.boolean().optional(),
  /** When true, Featured tab shows care gaps; omit or false hides it (no care-gaps API call). */
  shouldShowCareGaps: z.boolean().optional(),
  shouldShowSidepanelAiAnalysis: z.literal(true).optional(),
});
export type CxFeatureFlags = z.infer<typeof cxFeatureFlagsSchema>;
